
import { Component, Input, Output, EventEmitter, OnInit, ViewChild, Inject } from '@angular/core';
import { GetQuestionsFromJson } from "../shared/services/get-questions-from-json";
import { BroadcastEventService } from "../shared/services/broadcast.event.service";
import { Questions } from "../classes/question";
import { Subscription } from "rxjs";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { EditQuestionDialogComponent } from "../editQuestionDialog/edit-question-dialog.component";
import { SecondLanguageService } from "../shared/services/second-language.service";
import { RepeaterFormOpenService } from "../shared/services/repeater-form-open.service";
import { AbstractResolver } from "codelyzer/angular/urlResolvers/abstractResolver";
import { AreYouSureDialogComponent } from "./dependenQuestions/are-you-sure-dialog/are-you-sure-dialog-component";
import { LeftTabActiveService } from "../shared/services/left-tab-active.service";
import { Age } from "../classes/age";
import { BroadcastAgeService } from "../shared/services/broadcast-age.service";
import { EditAgeDialogComponent } from "../editAgeDialog/edit-age-dialog.component";
import { SettingsOpenService } from "../shared/services/settings-open.service";
import { Anomalies } from "../classes/anomaly";
import { BroadcastAnomaliesService } from "../shared/services/broadcast-anomalies.service";
import { EditAnomalyDialogComponent } from "../editAnomalyDialog/edit-anomaly-dialog.component";
import { UserResponse } from "../classes/user-response";
import { BroadcastUserResService } from "../shared/services/broadcast-user-res.service";
import { CascadingJSONService } from "../shared/services/cascading-json.service";
import { RestApiService } from "../shared/restApiServices/restapi.service";
import { Response } from "../classes/response";
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ToastyService, ToastyConfig, ToastOptions, ToastData } from 'ng2-toasty';
import { ShowToastyService } from "../shared/services/showToastyService";
import { QuestionnaireTypeService } from "../shared/services/questionnaire-type-service.service";
import { DefineAreaModalComponent } from 'app/define-area-modal/define-area-modal.component';

@Component({
  selector: 'central-panel',
  templateUrl: './central-panel.component.html',
  styleUrls: ['./central-panel.component.css']
})

export class CentralPanelComponent implements OnInit {
  questions: Questions[];
  showSecLangQues: boolean;
  ages : Age[];
  anomalies : Anomalies[];
  errorMessage : string;
  repeaterQuestionActive : Questions;
  qID:string;
  casLoc:any;
  showLoader:boolean;
  dropdownMenuDisplay:boolean;
  numOfQuestions:number;
  lastpublishedDate;

  //Number of parents in a dep questions
  //Used to terminate a infinite loop
  maxTries: number = 15;


  moveUpClass: string = "";
  moveDownClass: string = "";




  questionsSubscription: Subscription;


  forIndexes: number[];


  languages: string[];

  showOptions = false;

  tabs: Tabs[] = [{
    name: "main",
    label: "Untitled Form",
    class: "active",
    isVisible: true
  }, {
    name: "form",
    label: "Repeater Form",
    class: "inactive",
    isVisible: false
  }, {
    name: "anomalies",
    label: "Anomalies",
    class: "inactive",
    isVisible: false
  }, {
    name: "age",
    label: "Age Condition",
    class: "inactive",
    isVisible: false
  }];
  questionTypesList: QuestionTypes[];
  isNotASubFormOrMasterForm:boolean;

  constructor(private router: Router, public route: ActivatedRoute,
     private restApiService: RestApiService, private cascadingJSONService: CascadingJSONService, 
     private getQuestionsFromJson: GetQuestionsFromJson, 
     private broadcastEventService: BroadcastEventService, public editQuestionDialog: MatDialog, 
     private editAgeDialog: MatDialog, private secondLanguageService: SecondLanguageService, 
     private repeaterFormOpen: RepeaterFormOpenService, public areYouSure: MatDialog, 
     private leftTabActiveService: LeftTabActiveService, private ageService: BroadcastAgeService, 
     private settingsOpenService: SettingsOpenService, 
     private anomaliesService: BroadcastAnomaliesService, private editAnomalyDialog: MatDialog,
      private userResService: BroadcastUserResService, private toastyService: ToastyService, 
      private questionsTypes: QuestionnaireTypeService, private showToastyService:ShowToastyService,
      public dialog: MatDialog) {
    this.questionsSubscription = this.broadcastEventService.getQuestions().subscribe(message => { 
      if (message != null) 
      { this.questions = message; } 
    });
    this.questionsSubscription = this.anomaliesService.getAnomalies().subscribe(message => { 
      if (message != null)
        { this.anomalies = message }
      });
    this.questionsSubscription = this.cascadingJSONService.getCascad().subscribe(message => {
       if (message != null) 
       { this.casLoc = message } 
      });
    this.languages = this.secondLanguageService.getLanguages();
    this.questionsSubscription = this.ageService.getAges().subscribe(message =>{
      if(message != null)
      {
        this.ages = message
      }
    })
    this.showSecLangQues = false;
    //TODO will become complicated once session and user ids gets implemented

    this.questions = [];
    this.anomalies = [];
    this.casLoc = {};
    this.showLoader = false;
    this.questionTypesList = questionsTypes.getQuestionsTypesList();
    this.route.params.subscribe(params => {
      this.qID = params['id'];
      // broadcastEventService.setQuestions(JSON.parse(localStorage.getItem(this.qID)));
      // anomaliesService.setAnomalies(JSON.parse(localStorage.getItem(this.qID+"Anomalies")));
      this.leftTabActiveService.setLeftTab("main");
      this.settingsOpenService.setSettingsOpen(false);
    });

  }


  ngOnInit() {

    this.getQuestions(this.qID);
  }

  getQuestions(qID) {

    this.restApiService.getQnrWithDetailsService(qID).subscribe(
        questions => {
          // get question only which is same as this.qID
          let result = questions.result;
          let newQuestionList  = [];
          for (let index = 0; index < result.length; index++) {
            if(result[index].qID == this.qID){
              newQuestionList.push(result[index]);
            }
          }
          questions.result= newQuestionList;
          if(questions.result[0].second_lang)
          {
            this.showSecLangQues = true;
          }
          this.isNotASubFormOrMasterForm = questions.result[0].child_group !=null || questions.result[0].parent_group != null ? true : false;
          this.numOfQuestions = questions.result[0].num_qns;
          this.lastpublishedDate = questions.result[0].lastPublishedOn;
          this.dropdownMenuDisplay=this.numOfQuestions>=6;
          this.updateQuestions(questions);
          this.updateAnomalies(questions);
          this.updateSecondLanguage(questions);
          this.updateCascadeLocation(questions);
        },

        error =>  this.errorMessage = <any>error,
    );

  }

  updateSecondLanguage(result) {
    if (result.success) {
      this.languages = [result.result[0].primary_lang, result.result[0].second_lang];
      this.secondLanguageService.setLanguages(this.languages);
    }
  }

  updateCascadeLocation(result) {
    // console.log('updating');
    if (result.success && result.result[0].cascadeLocation) {
      // console.log('in cascasde');
      // console.log(result.result[0].cascadeLocation);
      this.cascadingJSONService.setCascad(result.result[0].cascadeLocation);
      // this.restApiService.updateQnrService(this.qID,JSON.stringify(this.questions),JSON.stringify(this.anomalies),JSON.stringify(result.result[0].cascadeLocation),'d').subscribe(result => {});
    }
  }
  // getAnomalies(){
  //   this.getQuestionsFromJson.getAnomalies().subscribe(anomalies => {this.updateAnomalies(anomalies)});
  // }

  updateAnomalies(result) {
    if (result.success && result.result[0].anamoly) {
      this.anomalies = result.result[0].anamoly;

      for (let i = 0; i < this.anomalies.length; i++) {
        if (this.anomalies[i].Rule.indexOf('&') !== -1) {
          this.anomalies[i].dispValue = 'Dependent Anomaly';
        } else {
          this.anomalies[i].dispValue = 'Simple Anomaly';
        }
      }

      this.anomaliesService.setAnomalies(this.anomalies);
      // this.restApiService.updateQnrService(this.qID,JSON.stringify(this.questions),JSON.stringify(this.anomalies),JSON.stringify(this.casLoc),'d').subscribe(result => {});
      localStorage.setItem(this.qID + "Anomalies", JSON.stringify(this.anomalies));
    }
  }

  updateQuestions(result) {

    if (result.success) {
      let qns = result.result[0].question;
      this.tabs[0].label = result.result[0].surveyName;
      if (qns) {
        for (let i = 0; i < qns.length; i++) {
          qns[i].Qn_Disp_Value = this.getDispValue(qns[i].Qn_Type);
        }
        this.forIndexes = new Array<number>(qns.length);

        for (let i = 0; i < qns.length; i++) {
          qns[i].user_Res = [""];
        }

        localStorage.setItem(this.qID, JSON.stringify(qns));
        this.broadcastEventService.setQuestions(qns);
        // this.restApiService.updateQnrService(this.qID,JSON.stringify(qns),JSON.stringify(this.anomalies),JSON.stringify(this.casLoc),'d').subscribe(result => {});
        // this.broadcastEventService.setQuestions(this.questions);
      }
    }
  }

  navigateToDashBoard() {
    this.router.navigateByUrl('/questionnaires');
  }

  createQuestions(){
    if (this.questions.length == 0) {
      let toastOptions: ToastOptions = {
        title: "Unable to create survey",
        msg: "Please add some questions to create a survey.",
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.warning(toastOptions);
      return;
    }
    let data = {
      surveyId:this.qID,
      surveyName:this.tabs[0].label}
    let dialogRef = this.dialog.open(AssignTeamComponent, {
      width: '68%',
      height: '600px',
      data: data,
      disableClose:true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.publishQuestions();
      this.navigateToDashBoard();
    });
  }

  publishQuestions() {

    let status = 'p';
    this.showLoader = true;
    if (this.questions.length > 0) {
      this.restApiService.updateQnrService(this.qID, JSON.stringify(this.questions), JSON.stringify(this.anomalies), JSON.stringify(this.casLoc), status).subscribe(
        result => {
          // console.log(result);
          this.showLoader = false;
          if (result.success != false) {
            this.lastpublishedDate = result.result.length > 0 ? result.result[0].lastPublishedOn : this.lastpublishedDate;
            var toastOptions: ToastOptions = {
              title: "Published",
              msg: "Your Survey has Successfully published",
              showClose: true,
              timeout: 3000,
              theme: 'bootstrap'
            };
            this.toastyService.success(toastOptions);
            //redirect to dashboard
            // setTimeout(function () {
            //   this.router.navigateByUrl('/questionnaires');
            // },1000);

          }
          else {
            // console.log("fail"+result.msg);
            var toastOptions: ToastOptions = {
              title: "Could not Publish",
              msg: result.msg,
              showClose: true,
              timeout: 3000,
              theme: 'bootstrap'
            };
            this.toastyService.error(toastOptions);
          }

        });
    }
    else {
      console.log('no question present');
    }

  }

  createTemplate() {

    this.showLoader = true;
    if (this.questions.length > 0) {
      //mahima - description
      this.restApiService.makeTemplate(JSON.stringify(this.questions), JSON.stringify(this.anomalies), JSON.stringify(this.casLoc), this.tabs[0].label, 'Description').subscribe(
        result => {
          this.showLoader = false;
          if (result.success != false) {
            var toastOptions: ToastOptions = {
              title: "Template Created",
              msg: "Template has been created!!",
              showClose: true,
              timeout: 3000,
              theme: 'bootstrap'
            };
            this.toastyService.success(toastOptions);
          }
          else {
            var toastOptions: ToastOptions = {
              title: "Could not Publish",
              msg: result.msg,
              showClose: true,
              timeout: 3000,
              theme: 'bootstrap'
            };
            this.toastyService.error(toastOptions);
          }

        });
    }
    else {
      console.log('no question present');
    }

  }

  editQuestion(i: number) {

    //TODO: Only for testing with HH.json
    //TODO: Might be needed afterwords as well
    if (!this.questions[i - 1].Qn_Disp_Value) {
      this.questions[i - 1].Qn_Disp_Value = this.getDispValue(this.questions[i - 1].Qn_Type);
    }
    if (this.questions[i - 1].Parent_Dep) {
      let dialogRef = this.editQuestionDialog.open(EditQuestionDialogComponent, {
        data: {
          question: this.questions[i - 1],
          parentQuestion: this.questions[this.questions[i - 1].Parent_Dep - 1]
        },
        height: '560px',
        width: '1120px',
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe(result => {

        if (result != null) {
          this.questions[i - 1] = result;


          for (let i = 0; i < this.questions.length; i++) {
            this.questions[i].user_Res = [""];
          }
          localStorage.setItem(this.qID, JSON.stringify(this.questions));
          this.broadcastEventService.setQuestions(this.questions);

          this.anomalies = [];
          localStorage.setItem(this.qID + "Anomalies", JSON.stringify(this.anomalies));
          this.anomaliesService.setAnomalies(this.anomalies);
          this.restApiService.updateQnrService(this.qID, JSON.stringify(this.questions), JSON.stringify(this.anomalies), JSON.stringify(this.casLoc), 'd').subscribe(result => { });
        }
      });
    } else {
      let dialogRef = this.editQuestionDialog.open(EditQuestionDialogComponent, {
        data: {
          question: this.questions[i - 1],
          parentQuestion: null
        },
        height: '560px',
        width: '1120px',
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe(result => {

        if (result != null) {

          this.questions[i - 1] = result;


          for (let i = 0; i < this.questions.length; i++) {
            this.questions[i].user_Res = [""];
          }
          localStorage.setItem(this.qID, JSON.stringify(this.questions));
          this.broadcastEventService.setQuestions(this.questions);

          this.anomalies = [];
          localStorage.setItem(this.qID + "Anomalies", JSON.stringify(this.anomalies));
          this.anomaliesService.setAnomalies(this.anomalies);
          this.restApiService.updateQnrService(this.qID, JSON.stringify(this.questions), JSON.stringify(this.anomalies), JSON.stringify(this.casLoc), 'd').subscribe(result => { });
        }
      });
    }

  }

  getDispValue(type: string): string {
    if (type === "CalendarWithDate") {
      return "Calendar";
    } else if (type === "MobileNumMax10") {
      return "Number";
    } else {
      let indexOfQuestion = this.questionTypesList.findIndex(question=> question.questionType === type);
      if(indexOfQuestion > -1){
        return this.questionTypesList[indexOfQuestion].displayValue;
      }
      else {
        return "Number";
      }
    }
  }


  questionsOrderChanged() {

    for (let i = 0; i < this.questions.length; i = i + 1) {
      this.questions[i].Qn_Num = i + 1;
      this.questions[i].Qn_In = this.questions[i].Qn_Num.toString();
    }

    this.broadcastEventService.setQuestions(this.questions);
    this.restApiService.updateQnrService(this.qID, JSON.stringify(this.questions), JSON.stringify(this.anomalies), JSON.stringify(this.casLoc), 'd').subscribe(result => { });
  }


  showDepQuestions(i) {

    //TODO: check in last if it can be removed as if clean json is formed then the below condition will never occur
    if (!this.questions[i].Qn_Deps || this.questions[i].Qn_Deps.length <= 0) {
      return;
    }
    //TODO: Remove the first check after creating our own json as it will become unnecessary only for test jsons
    if (this.questions[i].Is_Sub_Visible && this.questions[i].Is_Sub_Visible === true) {
      this.questions[i].Is_Sub_Visible = false;
    } else {
      this.questions[i].Is_Sub_Visible = true;
    }
  }

  showRepeaterForm(i) {
    //TODO: ceck in last if it can be removed as if clean json is formed then the below condition will never occur
    if (!this.questions[i].Repeater || this.questions[i].Qn_Repeat.length <= 0) {
      return;
    }
    //TODO: Remove the first check after creating our own json as it will become unnecessary only for test jsons
    if (this.questions[i].Is_Sub_Visible && this.questions[i].Is_Sub_Visible === true) {
      this.questions[i].Is_Sub_Visible = false;
    } else {
      this.questions[i].Is_Sub_Visible = true;
    }
  }



  showSub(res: string[]) {
    let i = parseInt(res[0]);
    i = i - 1;
    //TODO: ceck in last if it can be removed as if clean json is formed then the below condition will never occur
    if (!this.questions[i].Qn_Deps || this.questions[i].Qn_Deps.length <= 0) {
      return;
    }
    //TODO: Remove the first check after creating our own json as it will become unnecessary only for test jsons
    if (this.questions[i].Is_Sub_Visible && this.questions[i].Is_Sub_Visible === true) {
      this.questions[i].Is_Sub_Visible = false;
    } else {
      this.questions[i].Is_Sub_Visible = true;
    }
  }



  sendSubQues(i: number): Questions[] {
    let newSubQuest = [];
    if(this.questions[i - 1].Qn_Deps && this.questions[i - 1].Qn_Deps.length >0){
      let parentString = `${this.questions[i-1].Qn_In + '.'}`;
      this.questions.forEach(question =>{
        if(question.Qn_In.startsWith(parentString)){
          newSubQuest.push(question);
        }
      })
    }
    return newSubQuest;
    // let newSubQuest = [];
    // if(this.questions[i - 1].Qn_Deps && this.questions[i - 1].Qn_Deps.length >0){
    //   this.questions[i - 1].Qn_Deps.forEach(index=>{
    //     const newIndex = index-1>=0?index-1:0;
    //     newSubQuest.push(this.questions[newIndex]);
    //   })
    // }
    // let subQues = this.questions.slice(i, i + this.questions[i - 1].Qn_Deps.length);
    // console.log('sub questions',newSubQuest);
    // return subQues;
    // return newSubQuest;
  }



  openRepeaterForm(q_num: number) {
    this.tabs[0].class = "inactive";
    this.tabs[1].class = "active";
    this.tabs[2].class = "inactive";
    this.tabs[3].class = "inactive";
    this.tabs[1].isVisible = true;
    this.tabs[2].isVisible = false;
    this.tabs[3].isVisible = false;
    this.repeaterQuestionActive = this.questions[q_num - 1];
    this.repeaterFormOpen.setRepeaterParent(q_num);
    this.leftTabActiveService.setLeftTab("main");
  }


  saveAndCloseRepeaterForm() {

    //ToDo : May become complicated once I start saving the changes
    this.tabs[1].class = "inactive";
    this.tabs[1].isVisible = false;
    this.tabs[0].class = "active";
    this.repeaterQuestionActive = null;
    this.repeaterFormOpen.setRepeaterParent(null);
    this.leftTabActiveService.setLeftTab("main");
  }


  manageAnomalies() {

    if (this.tabs[0].class !== 'active') {
      return;
    }


    this.tabs[0].class = "inactive";
    this.tabs[1].class = "inactive";
    this.tabs[2].class = "active";
    this.tabs[3].class = "inactive";
    this.tabs[1].isVisible = false;
    this.tabs[2].isVisible = true;
    this.tabs[3].isVisible = false;
    this.leftTabActiveService.setLeftTab("anomaly");
  }

  addAgeCondition() {

    if (this.tabs[0].class !== 'active') {
      return;
    }

    this.tabs[0].class = "inactive";
    this.tabs[1].class = "inactive";
    this.tabs[2].class = "inactive";
    this.tabs[3].class = "active";
    this.tabs[1].isVisible = false;
    this.tabs[2].isVisible = false;
    this.tabs[3].isVisible = true;
    this.leftTabActiveService.setLeftTab("age");
    this.ages = [];
    this.ageService.setAges(this.ages);
    let ageMap: Map<string, Age> = new Map<string, Age>();
    let keyArray: string[] = [];


    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i].Parent_Age !== null) {
        let key = this.questions[i].Parent_Age.toString() + "-" + this.questions[i].Age_Range[0] + "-" + this.questions[i].Age_Range[1];
        if (ageMap.has(key)) {
          let newAge: Age = ageMap.get(key);
          newAge.childs.push(this.questions[i].Qn_Num);
        } else {
          let newAge = new Age();
          newAge.key = key;
          newAge.parent = this.questions[i].Parent_Age;
          newAge.low = this.questions[i].Age_Range[0];
          newAge.high = this.questions[i].Age_Range[1];
          newAge.childs = [this.questions[i].Qn_Num];
          newAge.childsVisible = false;
          ageMap.set(key, newAge);
          keyArray.push(key);
        }
      }
    }
    keyArray.sort();
    if (!this.ages) {
      this.ages = [];
    }
    for (let i = 0; i < keyArray.length; i++) {
      this.ages.push(ageMap.get(keyArray[i]));
    }
    this.ageService.setAges(this.ages);
  }

  saveAndCloseAnomalies() {
    this.tabs[2].class = "inactive";
    this.tabs[2].isVisible = false;
    this.tabs[0].class = "active";
    this.leftTabActiveService.setLeftTab("main");
  }

  saveAndCloseAgeCondition() {
    this.tabs[3].class = "inactive";
    this.tabs[3].isVisible = false;
    this.tabs[0].class = "active";

    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i].Parent_Age) {
        this.questions[i].Parent_Age = null;
        this.questions[i].Age_Range.pop();
        this.questions[i].Age_Range.pop();
      }
    }

    for (let i = 0; i < this.ages.length; i++) {

      for (let j = 0; j < this.ages[i].childs.length; j++) {
        this.questions[this.ages[i].childs[j] - 1].Parent_Age = this.ages[i].parent;
        this.questions[this.ages[i].childs[j] - 1].Age_Range.push(this.ages[i].low);
        this.questions[this.ages[i].childs[j] - 1].Age_Range.push(this.ages[i].high);
      }

    }

    for (let i = 0; i < this.questions.length; i++) {
      this.questions[i].user_Res = [""];
    }
    localStorage.setItem(this.qID, JSON.stringify(this.questions));
    this.broadcastEventService.setQuestions(this.questions);
    this.leftTabActiveService.setLeftTab("main");
    this.restApiService.updateQnrService(this.qID, JSON.stringify(this.questions), JSON.stringify(this.anomalies), JSON.stringify(this.casLoc), 'd').subscribe(result => { });
  }


  addDepQuestion(disType: number, parent: number) {
    
    let newDepQuestion = this.getNewQuestion();

    newDepQuestion.Qn_Disp_Value = this.questionTypesList[disType].displayValue;
    newDepQuestion.Qn_Type = this.questionTypesList[disType].questionType;
    newDepQuestion.Parent_Dep = parent;
    newDepQuestion.Parent_Repeat = parent-1>=0 && this.questions[parent-1].Parent_Repeat?this.questions[parent-1].Parent_Repeat:null;

    newDepQuestion.Is_Cond = true;
    let dialogRef = this.editQuestionDialog.open(EditQuestionDialogComponent, {
      data: {
        question: newDepQuestion,
        parentQuestion: this.questions[parent - 1]
      },
      height: '560px',
      width: '1120px',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {



      if (result != null) {
        newDepQuestion = result;

        let count = 0;
        for (let i = 0; i < this.questions[parent - 1].Qn_Deps.length; i++) {
          if (this.questions[this.questions[parent - 1].Qn_Deps[i] - 1].Parent_Dep === parent) {
            count++;
          }
        }
        newDepQuestion.Qn_In = this.questions[parent - 1].Qn_In + "." + (count + 1);
        newDepQuestion.Qn_Num = this.questions[parent - 1].Qn_Num + this.questions[parent - 1].Qn_Deps.length + 1;

        let tempParent = parent;



        for (let i = newDepQuestion.Qn_Num - 1; i < this.questions.length; i++) {

          this.questions[i].Qn_Num = this.questions[i].Qn_Num + 1;

          this.maxTries = 15;
          if (this.questions[i].Parent_Dep !== null) {
            tempParent = this.questions[i].Parent_Dep;
            while (tempParent !== null) {
              if (tempParent < newDepQuestion.Qn_Num) {
                this.questions[tempParent - 1].Qn_Deps[this.questions[tempParent - 1].Qn_Deps.indexOf(this.questions[i].Qn_Num - 1)] = this.questions[i].Qn_Num;
                tempParent = this.questions[tempParent - 1].Parent_Dep;
              }
              else {
                this.questions[tempParent - 2].Qn_Deps[this.questions[tempParent - 2].Qn_Deps.indexOf(this.questions[i].Qn_Num - 1)] = this.questions[i].Qn_Num;
                tempParent = this.questions[tempParent - 2].Parent_Dep;
              }
              this.maxTries = this.maxTries - 1;
              if (this.maxTries <= 0) {
                console.log("infinite loop");
                break;
              }

            }
          }

          if (this.questions[i].Parent_Repeat != null) {
            tempParent = this.questions[i].Parent_Repeat;
            if (tempParent < newDepQuestion.Qn_Num) {
              this.questions[tempParent - 1].Qn_Repeat[this.questions[tempParent - 1].Qn_Repeat.indexOf(this.questions[i].Qn_Num - 1)] = this.questions[i].Qn_Num;
            } else {
              this.questions[tempParent - 2].Qn_Repeat[this.questions[tempParent - 2].Qn_Repeat.indexOf(this.questions[i].Qn_Num - 1)] = this.questions[i].Qn_Num;
            }
          }    

          if (this.questions[i].Qn_Deps.length > 0) {
            for (let j = 0; j < this.questions[i].Qn_Deps.length; j++) {
              this.questions[this.questions[i].Qn_Deps[j] - 1].Parent_Dep = this.questions[i].Qn_Num;
            }
          }

          if (this.questions[i].Qn_Repeat.length > 0) {
            for (let j = 0; j < this.questions[i].Qn_Repeat.length; j++) {
              this.questions[this.questions[i].Qn_Repeat[j] - 1].Parent_Repeat = this.questions[i].Qn_Num;
            }
          }

          if (this.questions[i].Is_Age_Parent) {
            for (let k = 0; k < this.questions.length; k++) {
              if (this.questions[k].Parent_Age && this.questions[k].Parent_Age === (this.questions[i].Qn_Num - 1)) {
                this.questions[k].Parent_Age = this.questions[i].Qn_Num;
              }
            }
          }

        }
        tempParent = parent;
        this.maxTries = 15;
        while (tempParent != -1) {
          this.questions[tempParent - 1].Qn_Deps.push(newDepQuestion.Qn_Num);
          this.questions[tempParent - 1].Is_Sub_Visible = true;
          if (this.questions[tempParent - 1].Parent_Dep) {
            tempParent = this.questions[tempParent - 1].Parent_Dep;
          } else {
            tempParent = -1;
          }

          this.maxTries = this.maxTries - 1;
          if (this.maxTries <= 0) {
            console.log(" infinite loop");
            break;
          }
        }
        this.questions.splice(newDepQuestion.Qn_Num - 1, 0, newDepQuestion);

        for (let i = 0; i < this.questions.length; i++) {
          if (this.questions[i].Qn_Deps.length > 0) {
            this.questions[i].Qn_Deps.sort(function (a, b) { return a - b });
          }
          if (this.questions[i].Qn_Repeat.length > 0) {
            this.questions[i].Qn_Repeat.sort(function (a, b) { return a - b });
          }
        }



        for (let i = 0; i < this.questions.length; i++) {
          this.questions[i].user_Res = [""];
        }

        // adding current question Qn_Num in the repeater Parent qn if not present
        const currentQuestion = this.questions.findIndex(data=> data.Qn_Num == newDepQuestion.Qn_Num);
        const qnRepeaterParent = currentQuestion != -1?this.questions[currentQuestion].Parent_Repeat:null;
        // adding currentQuestion Qn_Num to the parent if not present
        const repeaterChild:number[] = qnRepeaterParent? this.questions[qnRepeaterParent-1].Qn_Repeat:[];
        const currentQuestionQn_Num = currentQuestion != -1?this.questions[currentQuestion].Qn_Num:-1;
        if(currentQuestionQn_Num !=-1 && repeaterChild && repeaterChild.length>0 && !(repeaterChild.includes(currentQuestionQn_Num))){
          this.questions[qnRepeaterParent-1].Qn_Repeat.push(currentQuestionQn_Num);
        }
        localStorage.setItem(this.qID, JSON.stringify(this.questions));
        this.broadcastEventService.setQuestions(this.questions);

        this.anomalies = [];
        localStorage.setItem(this.qID + "Anomalies", JSON.stringify(this.anomalies));
        this.anomaliesService.setAnomalies(this.anomalies);
        this.restApiService.updateQnrService(this.qID, JSON.stringify(this.questions), JSON.stringify(this.anomalies), JSON.stringify(this.casLoc), 'd').subscribe(result => { });
      }
    });

  }

  addDepQuestionInRepeat(disType: number, parent: number) {
    let newDepQuestion = this.getNewQuestion();
    newDepQuestion.Qn_Disp_Value = this.questionTypesList[disType].displayValue;
    newDepQuestion.Qn_Type = this.questionTypesList[disType].questionType;
    newDepQuestion.Parent_Dep = parent;
    newDepQuestion.Parent_Repeat = this.repeaterQuestionActive.Qn_Num;
    newDepQuestion.Is_Cond = true;

    let dialogRef = this.editQuestionDialog.open(EditQuestionDialogComponent, {
      data: {
        question: newDepQuestion,
        parentQuestion: this.questions[parent - 1]
      },
      height: '560px',
      width: '1120px',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != null) {
        newDepQuestion = result;




        let numberOfSiblings = this.questions[parent - 1].Qn_Deps.length;
        let count = 0;
        for (let i = 0; i < this.questions[parent - 1].Qn_Deps.length; i++) {
          if (this.questions[this.questions[parent - 1].Qn_Deps[i] - 1].Parent_Dep === parent) {
            count++;
          }
        }
        newDepQuestion.Qn_In = this.questions[parent - 1].Qn_In + "." + (count + 1);
        newDepQuestion.Qn_Num = this.questions[parent - 1].Qn_Num + numberOfSiblings + 1;


        let tempParent: any;
        for (let i = newDepQuestion.Qn_Num - 1; i < this.questions.length; i++) {



          this.questions[i].Qn_Num = this.questions[i].Qn_Num + 1;


          this.maxTries = 15;
          if (this.questions[i].Parent_Dep !== null) {
            tempParent = this.questions[i].Parent_Dep;
            while (tempParent !== null) {

              if (tempParent < newDepQuestion.Qn_Num) {
                this.questions[tempParent - 1].Qn_Deps[this.questions[tempParent - 1].Qn_Deps.indexOf(this.questions[i].Qn_Num - 1)] = this.questions[i].Qn_Num;
                tempParent = this.questions[tempParent - 1].Parent_Dep;
              }
              else {
                this.questions[tempParent - 2].Qn_Deps[this.questions[tempParent - 2].Qn_Deps.indexOf(this.questions[i].Qn_Num - 1)] = this.questions[i].Qn_Num;
                tempParent = this.questions[tempParent - 2].Parent_Dep;
              }
              this.maxTries = this.maxTries - 1;
              if (this.maxTries <= 0) {
                console.log("infinite loop");
                break;
              }
            }


          }

          if (this.questions[i].Parent_Repeat !== null) {
            tempParent = this.questions[i].Parent_Repeat;
            if (tempParent < newDepQuestion.Qn_Num) {
              this.questions[tempParent - 1].Qn_Repeat[this.questions[tempParent - 1].Qn_Repeat.indexOf(this.questions[i].Qn_Num - 1)] = this.questions[i].Qn_Num;
            } else {
              this.questions[tempParent - 2].Qn_Repeat[this.questions[tempParent - 2].Qn_Repeat.indexOf(this.questions[i].Qn_Num - 1)] = this.questions[i].Qn_Num;
            }
          }

          if (this.questions[i].Is_Age_Parent) {
            for (let k = 0; k < this.questions.length; k++) {
              if (this.questions[k].Parent_Age && this.questions[k].Parent_Age === (this.questions[i].Qn_Num - 1)) {
                this.questions[k].Parent_Age = this.questions[i].Qn_Num;
              }
            }
          }

          if (this.questions[i].Qn_Deps.length > 0) {
            for (let j = 0; j < this.questions[i].Qn_Deps.length; j++) {
              this.questions[this.questions[i].Qn_Deps[j] - 1].Parent_Dep = this.questions[i].Qn_Num;
            }
          }

          if (this.questions[i].Qn_Repeat.length > 0) {
            for (let j = 0; j < this.questions[i].Qn_Repeat.length; j++) {
              this.questions[this.questions[i].Qn_Repeat[j] - 1].Parent_Repeat = this.questions[i].Qn_Num;
            }
          }


        }
        tempParent = parent;
        this.maxTries = 15;
        while (tempParent != -1) {
          this.questions[tempParent - 1].Qn_Deps.push(newDepQuestion.Qn_Num);
          this.questions[tempParent - 1].Is_Sub_Visible = true;
          if (this.questions[tempParent - 1].Parent_Dep) {
            tempParent = this.questions[tempParent - 1].Parent_Dep;
          } else {
            tempParent = -1;
          }

          this.maxTries = this.maxTries - 1;
          if (this.maxTries <= 0) {
            console.log("infinite loop");
            break;
          }
        }


        this.questions[this.repeaterQuestionActive.Qn_Num - 1].Qn_Repeat.push(newDepQuestion.Qn_Num);

        this.questions.splice(newDepQuestion.Qn_Num - 1, 0, newDepQuestion);
        for (let i = 0; i < this.questions.length; i++) {
          if (this.questions[i].Qn_Deps.length > 0) {
            this.questions[i].Qn_Deps.sort(function (a, b) { return a - b });
          }
          if (this.questions[i].Qn_Repeat.length > 0) {
            this.questions[i].Qn_Repeat.sort(function (a, b) { return a - b });
          }
        }



        for (let i = 0; i < this.questions.length; i++) {
          this.questions[i].user_Res = [""];
        }
        localStorage.setItem(this.qID, JSON.stringify(this.questions));
        this.broadcastEventService.setQuestions(this.questions);

        this.anomalies = [];
        localStorage.setItem(this.qID + "Anomalies", JSON.stringify(this.anomalies));
        this.anomaliesService.setAnomalies(this.anomalies);
        this.restApiService.updateQnrService(this.qID, JSON.stringify(this.questions), JSON.stringify(this.anomalies), JSON.stringify(this.casLoc), 'd').subscribe(result => { });
      }
    });


  }

  addDepFromChild(command: number[]) {
    if (this.repeaterQuestionActive) {
      this.addDepQuestionInRepeat(command[0], command[1]);
    } else {
      this.addDepQuestion(command[0], command[1]);
    }
  }


  getNewQuestion(): Questions {

    let newQuestion = new Questions();
    newQuestion.Qn = "";
    newQuestion.S_Qn = "";


    //TODO: Might change after adding repeater and dependence


    newQuestion.Qn_Deps = [-1];
    newQuestion.Qn_Deps.pop();

    newQuestion.Opt_Dep = [-1];
    newQuestion.Opt_Dep.pop();

    newQuestion.Age_Range = [-1];
    newQuestion.Age_Range.pop();

    newQuestion.Repeater = false;

    newQuestion.Qn_Repeat = [-1];
    newQuestion.Qn_Repeat.pop();

    newQuestion.Opt_Name = [""];
    newQuestion.Opt_Name.pop();

    newQuestion.S_Opt_Name = [""];
    newQuestion.S_Opt_Name.pop();

    newQuestion.Is_Mandt = true;
    newQuestion.Is_Cond = false;

    newQuestion.Min_Char = 1;
    newQuestion.Max_Char = 500;
    newQuestion.IS_Anomaly = false;
    newQuestion.is_double_dependent = false;
    newQuestion.Repeat_Dependence = null;

    //New field to save user respond
    //Only numerical results are necessary for current app
    newQuestion.user_Res = [""];

    //To track whether current question is visible to user
    newQuestion.is_Visible = false;

    newQuestion.Is_Sub_Visible = false;

    //Set the initial parents of questions to be null
    newQuestion.Parent_Age = null;
    newQuestion.Parent_Dep = null;

    //Todo : think what will happen if repeater form is opened
    newQuestion.Parent_Repeat = null;

    newQuestion.Is_Age_Parent = false;


    return newQuestion;
  }


  addNewForm(parent: number) {
    this.repeaterFormOpen.setRepeaterParent(parent);
    this.tabs[0].class = "inactive";
    this.tabs[1].class = "active";
    this.tabs[1].isVisible = true;
    if (!this.questions[parent - 1].Repeater) {
      this.questions[parent - 1].Repeater = true;
    }
    this.repeaterQuestionActive = this.questions[parent - 1];


    for (let i = 0; i < this.questions.length; i++) {
      this.questions[i].user_Res = [""];
    }
    localStorage.setItem(this.qID, JSON.stringify(this.questions));
    this.broadcastEventService.setQuestions(this.questions);
    this.restApiService.updateQnrService(this.qID, JSON.stringify(this.questions), JSON.stringify(this.anomalies), JSON.stringify(this.casLoc), 'd').subscribe(result => { });

  }


  deleteQuestion(question_number: number) {

    this.numOfQuestions-=1;
    this.dropdownMenuDisplay=this.numOfQuestions>=6;
    //TODO : Will change if a question giving age is deleted
    //ToDO : after age is implemented

    let dialogRef = this.areYouSure.open(AreYouSureDialogComponent, {
      data: {
        cascad: false
      },
      height: '285px',
      width: '400px',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === "Yes") {

        this.delete(question_number);

      }


    });




  }


  delete(question_number: number) {
    if(this.questions[question_number - 1].Qn_Type =="Button"){
      this.casLoc = {};
    }

    if (this.questions[question_number - 1].Is_Age_Parent) {
      for (let i = 0; i < this.questions.length; i++) {
        if (this.questions[i].Parent_Age && this.questions[i].Parent_Age === question_number) {
          this.questions[i].Parent_Age = null;
          this.questions[i].Age_Range.pop();
          this.questions[i].Age_Range.pop();
        }
      }
    }

    let numToDelete: number;
    let tempParent: number;

    if (this.questions[question_number - 1].Qn_Deps.length > 0) {
      numToDelete = this.questions[question_number - 1].Qn_Deps.length + 1;

      if (this.questions[question_number - 1].Parent_Dep) {
        tempParent = this.questions[question_number - 1].Parent_Dep;
        while (tempParent !== null) {

          this.questions[tempParent - 1].Qn_Deps.splice(this.questions[tempParent - 1].Qn_Deps.indexOf(question_number), 1);
          for (let j = 0; j < this.questions[question_number - 1].Qn_Deps.length; j++) {
            this.questions[tempParent - 1].Qn_Deps.splice(this.questions[tempParent - 1].Qn_Deps.indexOf(this.questions[question_number - 1].Qn_Deps[j]), 1);
          }
          this.questions[tempParent - 1].Qn_Deps.sort(function (a, b) { return a - b });
          tempParent = this.questions[tempParent - 1].Parent_Dep;
        }
      }

      if (this.questions[question_number - 1].Parent_Repeat) {

        tempParent = this.questions[question_number - 1].Parent_Repeat;

        this.questions[tempParent - 1].Qn_Repeat.splice(this.questions[tempParent - 1].Qn_Repeat.indexOf(question_number), 1);
        for (let j = 0; j < this.questions[question_number - 1].Qn_Deps.length; j++) {
          this.questions[tempParent - 1].Qn_Repeat.splice(this.questions[tempParent - 1].Qn_Repeat.indexOf(this.questions[question_number - 1].Qn_Deps[j]), 1);
        }
        this.questions[tempParent - 1].Qn_Repeat.sort(function (a, b) { return a - b });

      }

    } else if (this.questions[question_number - 1].Qn_Repeat.length > 0) {
      numToDelete = this.questions[question_number - 1].Qn_Repeat.length + 1;
    } else {
      numToDelete = 1;
      if (this.questions[question_number - 1].Parent_Dep) {
        tempParent = this.questions[question_number - 1].Parent_Dep;
        while (tempParent !== null) {

          this.questions[tempParent - 1].Qn_Deps.splice(this.questions[tempParent - 1].Qn_Deps.indexOf(question_number), 1);

          this.questions[tempParent - 1].Qn_Deps.sort(function (a, b) { return a - b });
          tempParent = this.questions[tempParent - 1].Parent_Dep;
        }
      }

      if (this.questions[question_number - 1].Parent_Repeat) {

        tempParent = this.questions[question_number - 1].Parent_Repeat;
        this.questions[tempParent - 1].Qn_Repeat.splice(this.questions[tempParent - 1].Qn_Repeat.indexOf(question_number), 1);
        this.questions[tempParent - 1].Qn_Repeat.sort(function (a, b) { return a - b });
      }
    }

    for (let i = question_number + numToDelete - 1; i < this.questions.length; i++) {
      this.questions[i].Qn_Num = this.questions[i].Qn_Num - numToDelete;

      this.maxTries = 15;

      if (this.questions[i].Parent_Dep !== null) {

        tempParent = this.questions[i].Parent_Dep;

        while (tempParent !== null) {
          if (tempParent <= question_number - 1) {
            this.questions[tempParent - 1].Qn_Deps[this.questions[tempParent - 1].Qn_Deps.indexOf(this.questions[i].Qn_Num + numToDelete)] = this.questions[i].Qn_Num;
            this.questions[tempParent - 1].Qn_Deps.sort(function (a, b) { return a - b });
            tempParent = this.questions[tempParent - 1].Parent_Dep;
          }
          else {
            this.questions[tempParent + numToDelete - 1].Qn_Deps[this.questions[tempParent + numToDelete - 1].Qn_Deps.indexOf(this.questions[i].Qn_Num + numToDelete)] = this.questions[i].Qn_Num;
            this.questions[tempParent + numToDelete - 1].Qn_Deps.sort(function (a, b) { return a - b });
            tempParent = this.questions[tempParent + numToDelete - 1].Parent_Dep;
          }
          this.maxTries = this.maxTries - 1;
          if (this.maxTries <= 0) {
            console.log("infinite loop");
            break;
          }

        }
      }

      if (this.questions[i].Parent_Repeat != null) {
        tempParent = this.questions[i].Parent_Repeat;
        if (tempParent <= question_number - 1) {
          this.questions[tempParent - 1].Qn_Repeat[this.questions[tempParent - 1].Qn_Repeat.indexOf(this.questions[i].Qn_Num + numToDelete)] = this.questions[i].Qn_Num;
          this.questions[tempParent - 1].Qn_Repeat.sort(function (a, b) { return a - b });
        } else {
          this.questions[tempParent + numToDelete - 1].Qn_Repeat[this.questions[tempParent + numToDelete - 1].Qn_Repeat.indexOf(this.questions[i].Qn_Num + numToDelete)] = this.questions[i].Qn_Num;
          this.questions[tempParent + numToDelete - 1].Qn_Repeat.sort(function (a, b) { return a - b });
        }
      }

      if (this.questions[i].Is_Age_Parent != null) {
        for (let k = 0; k < this.questions.length; k++) {
          if (this.questions[k].Parent_Age && this.questions[k].Parent_Age === (this.questions[i].Qn_Num + numToDelete)) {
            this.questions[k].Parent_Age = this.questions[i].Qn_Num;
          }
        }
      }


      if (this.questions[i].Qn_Deps.length > 0) {
        for (let j = 0; j < this.questions[i].Qn_Deps.length; j++) {
          this.questions[this.questions[i].Qn_Deps[j] - 1].Parent_Dep = this.questions[i].Qn_Num;
        }
      }

      if (this.questions[i].Qn_Repeat.length > 0) {
        for (let j = 0; j < this.questions[i].Qn_Repeat.length; j++) {
          this.questions[this.questions[i].Qn_Repeat[j] - 1].Parent_Repeat = this.questions[i].Qn_Num;
        }
      }

    }
    this.questions.splice(question_number - 1, numToDelete);

    this.forIndexes = new Array<number>(this.questions.length);

    if (this.questions.length > 0)
      if(this.questions[0].Qn_Disp_Value == "Break")
      this.questions[0].Qn_In = "0";
    else
      this.questions[0].Qn_In = "1";

    for (let i = 1; i < this.questions.length; i++) {


      if (this.questions[i].Parent_Dep === null && this.questions[i].Parent_Repeat === null) {
        if(this.questions[i].Qn_Type!='Break')
        {
          this.questions[i].Qn_In = (parseInt(this.questions[i - 1].Qn_In) + 1).toString(); 
        }
        else
        this.questions[i].Qn_In = (parseInt(this.questions[i - 1].Qn_In)).toString();
      } else if (this.questions[i].Parent_Dep !== null) {
        if (!this.forIndexes[this.questions[i].Parent_Dep]) {
          this.forIndexes[this.questions[i].Parent_Dep] = 1;
        } else {
          this.forIndexes[this.questions[i].Parent_Dep] = this.forIndexes[this.questions[i].Parent_Dep] + 1;
        }
        this.questions[i].Qn_In = this.questions[this.questions[i].Parent_Dep - 1].Qn_In + "." + (this.forIndexes[this.questions[i].Parent_Dep]);
      } else if (this.questions[i].Parent_Repeat !== null) {
        let count = 1;
        for (let j = this.questions[i].Parent_Repeat; j < i; j++) {
          if (this.questions[j].Parent_Dep === null && this.questions[j].Qn_Type !="Break") {
            count++;
          }
        }
        this.questions[i].Qn_In = this.questions[this.questions[i].Parent_Repeat - 1].Qn_In + "." + count;
      }
    }



    for (let i = 0; i < this.questions.length; i++) {
      this.questions[i].user_Res = [""];
    }
    localStorage.setItem(this.qID, JSON.stringify(this.questions));
    this.broadcastEventService.setQuestions(this.questions);

    this.anomalies = [];
    localStorage.setItem(this.qID + "Anomalies", JSON.stringify(this.anomalies));
    this.anomaliesService.setAnomalies(this.anomalies);
    this.restApiService.updateQnrService(this.qID, JSON.stringify(this.questions), JSON.stringify(this.anomalies), JSON.stringify(this.casLoc), 'd').subscribe(result => { });
  }


  copyQuestion(question_number : number){
    this.numOfQuestions+=1;
    if(this.questions[question_number - 1]['Qn_Type'] == 'Button'){
      alert('Cascading type question can not be copied.');
      return;
    }
    if (!this.repeaterQuestionActive || this.repeaterQuestionActive === null) {

      let newQuestionNumber = this.questions.length + 1;
      let previousQuestionNumber: number;
      let diffInQuestionNumber = this.questions.length + 1 - question_number;
      let tempParent: number;
      let tempQuestion: Questions = JSON.parse(JSON.stringify(this.questions[question_number - 1]));
      if (tempQuestion.Parent_Age) {
        tempQuestion.Parent_Age = null;
        tempQuestion.Age_Range.pop();
        tempQuestion.Age_Range.pop();
      }
      this.questions.push(tempQuestion);
      if (this.questions[question_number - 1].Qn_Deps.length > 0) {
        for (let j = 0; j < this.questions[question_number - 1].Qn_Deps.length; j++) {
          this.questions.push(JSON.parse(JSON.stringify(this.questions[this.questions[question_number - 1].Qn_Deps[j] - 1])));
        }
      } else if (this.questions[question_number - 1].Qn_Repeat.length > 0) {
        for (let j = 0; j < this.questions[question_number - 1].Qn_Repeat.length; j++) {
          this.questions.push(JSON.parse(JSON.stringify(this.questions[this.questions[question_number - 1].Qn_Repeat[j] - 1])));
        }
      }

      for (let i = newQuestionNumber - 1; i < this.questions.length; i++) {

        previousQuestionNumber = this.questions[i].Qn_Num;
        this.questions[i].Qn_Num = newQuestionNumber;


        if (this.questions[i].Qn_Deps.length > 0) {
          for (let j = 0; j < this.questions[i].Qn_Deps.length; j++) {
            this.questions[this.questions[i].Qn_Deps[j] - 1 + diffInQuestionNumber].Parent_Dep = newQuestionNumber;
          }
        }

        if (this.questions[i].Qn_Repeat.length > 0) {
          for (let j = 0; j < this.questions[i].Qn_Repeat.length; j++) {
            this.questions[this.questions[i].Qn_Repeat[j] - 1 + diffInQuestionNumber].Parent_Repeat = newQuestionNumber;
          }
        }

        if (this.questions[i].Parent_Dep) {
          tempParent = this.questions[i].Parent_Dep;
          this.maxTries = 15;
          while (tempParent !== null) {
            this.questions[tempParent - 1].Qn_Deps[this.questions[tempParent - 1].Qn_Deps.indexOf(previousQuestionNumber)] = newQuestionNumber;
            this.questions[tempParent - 1].Qn_Deps.sort(function (a, b) { return a - b });
            this.maxTries = this.maxTries - 1;
            tempParent = this.questions[tempParent - 1].Parent_Dep;
            if (this.maxTries <= 0) {
              console.log("infinite loop" + tempParent);
              break;
            }
          }
        }
        if (this.questions[i].Parent_Repeat) {

          this.questions[this.questions[i].Parent_Repeat - 1].Qn_Repeat[this.questions[this.questions[i].Parent_Repeat - 1].Qn_Repeat.indexOf(previousQuestionNumber)] = newQuestionNumber;
          this.questions[this.questions[i].Parent_Repeat - 1].Qn_Repeat.sort(function (a, b) { return a - b });
        }

        if (this.questions[i].Is_Age_Parent != null) {
          for (let k = 0; k < this.questions.length; k++) {
            if (this.questions[k].Parent_Age && this.questions[k].Parent_Age === (previousQuestionNumber)) {
              this.questions[k].Parent_Age = newQuestionNumber;
            }
          }
        }



        newQuestionNumber++;



      }


      this.forIndexes = new Array<number>(this.questions.length);


      for (let i = question_number + diffInQuestionNumber - 1; i < this.questions.length; i++) {


        if (this.questions[i].Parent_Dep === null && this.questions[i].Parent_Repeat === null) {
          // this.questions[i].Qn_In = (parseInt(this.questions[i - 1].Qn_In) + 1).toString();
          if(this.questions[i].Qn_Type !='Break')
            this.questions[i].Qn_In = (parseInt(this.questions[i - 1].Qn_In) + 1).toString();
          else
            this.questions[i].Qn_In = (parseInt(this.questions[i - 1].Qn_In)).toString();
        } else if (this.questions[i].Parent_Dep !== null) {
          if (!this.forIndexes[this.questions[i].Parent_Dep]) {
            this.forIndexes[this.questions[i].Parent_Dep] = 1;
          } else {
            this.forIndexes[this.questions[i].Parent_Dep] = this.forIndexes[this.questions[i].Parent_Dep] + 1;
          }
          this.questions[i].Qn_In = this.questions[this.questions[i].Parent_Dep - 1].Qn_In + "." + (this.forIndexes[this.questions[i].Parent_Dep]);
        } else if (this.questions[i].Parent_Repeat !== null) {
          let count = 1;
          for (let j = this.questions[i].Parent_Repeat; j < i; j++) {
            if (this.questions[j].Parent_Dep === null && this.questions[j].Qn_Type !="Break") {
              count++;
            }
          }
          this.questions[i].Qn_In = this.questions[this.questions[i].Parent_Repeat - 1].Qn_In + "." + count;
        }
      }


    } else {

      let parentRepeater = this.repeaterQuestionActive.Qn_Num;
      let tempParent: number;
      let numOfQuesToAdd = 1;
      if (this.questions[question_number - 1].Qn_Deps.length > 0) {
        numOfQuesToAdd = numOfQuesToAdd + this.questions[question_number - 1].Qn_Deps.length;
      }



      for (let i = this.questions[parentRepeater - 1].Qn_Num + this.questions[parentRepeater - 1].Qn_Repeat.length; i < this.questions.length; i++) {

        let previousQuestionNumber = this.questions[i].Qn_Num;
        this.questions[i].Qn_Num = this.questions[i].Qn_Num + numOfQuesToAdd;


        if (this.questions[i].Qn_Deps.length > 0) {
          for (let j = 0; j < this.questions[i].Qn_Deps.length; j++) {
            this.questions[this.questions[i].Qn_Deps[j] - 1].Parent_Dep = this.questions[i].Qn_Num;
          }
        }

        if (this.questions[i].Qn_Repeat.length > 0) {
          for (let j = 0; j < this.questions[i].Qn_Repeat.length; j++) {
            this.questions[this.questions[i].Qn_Repeat[j] - 1].Parent_Repeat = this.questions[i].Qn_Num;
          }
        }

        if (this.questions[i].Parent_Dep) {

          tempParent = this.questions[i].Parent_Dep;
          this.maxTries = 15;
          while (tempParent !== null) {

            this.questions[tempParent - numOfQuesToAdd - 1].Qn_Deps[this.questions[tempParent - numOfQuesToAdd - 1].Qn_Deps.indexOf(previousQuestionNumber)] = this.questions[i].Qn_Num;
            this.questions[tempParent - numOfQuesToAdd - 1].Qn_Deps.sort(function (a, b) { return a - b });
            this.maxTries = this.maxTries - 1;
            tempParent = this.questions[tempParent - numOfQuesToAdd - 1].Parent_Dep;
            if (this.maxTries <= 0) {
              console.log("infinite loop" + tempParent);
              break;
            }

          }

        }

        if (this.questions[i].Parent_Repeat) {

          tempParent = this.questions[i].Parent_Repeat;

          this.questions[tempParent - numOfQuesToAdd - 1].Qn_Repeat[this.questions[tempParent - numOfQuesToAdd - 1].Qn_Repeat.indexOf(previousQuestionNumber)] = this.questions[i].Qn_Num;
          this.questions[tempParent - numOfQuesToAdd - 1].Qn_Repeat.sort(function (a, b) { return a - b });

        }

        if (this.questions[i].Is_Age_Parent != null) {
          for (let k = 0; k < this.questions.length; k++) {
            if (this.questions[k].Parent_Age && this.questions[k].Parent_Age === (previousQuestionNumber)) {
              this.questions[k].Parent_Age = this.questions[i].Qn_Num;
            }
          }
        }


      }

      let whereToAdd = this.questions[parentRepeater - 1].Qn_Repeat.length + this.questions[parentRepeater - 1].Qn_Num;

      this.questions.splice(whereToAdd, 0, JSON.parse(JSON.stringify(this.questions[question_number - 1])));
      whereToAdd++;
      if (this.questions[question_number - 1].Qn_Deps.length > 0) {
        for (let j = 0; j < this.questions[question_number - 1].Qn_Deps.length; j++) {
          this.questions.splice(whereToAdd, 0, JSON.parse(JSON.stringify(this.questions[this.questions[question_number - 1].Qn_Deps[j] - 1])));
          whereToAdd++;
        }
      }

      whereToAdd = this.questions[parentRepeater - 1].Qn_Repeat.length + this.questions[parentRepeater - 1].Qn_Num;

      for (let k = 0; k < numOfQuesToAdd; k++) {

        let newQuestionNumber = whereToAdd + k + 1;
        let previousQuestionNumber = this.questions[whereToAdd + k].Qn_Num;
        this.questions[whereToAdd + k].Qn_Num = newQuestionNumber;
        this.questions[parentRepeater - 1].Qn_Repeat.push(this.questions[whereToAdd + k].Qn_Num);

        if (this.questions[whereToAdd + k].Qn_Deps.length > 0) {
          for (let l = 1; l <= this.questions[whereToAdd + k].Qn_Deps.length; l++) {
            this.questions[whereToAdd + k + l].Parent_Dep = newQuestionNumber;
          }
        }

        if (this.questions[whereToAdd + k].Parent_Dep) {

          tempParent = this.questions[whereToAdd + k].Parent_Dep;

          this.maxTries = 15;
          while (tempParent !== null) {

            this.questions[tempParent - 1].Qn_Deps[this.questions[tempParent - 1].Qn_Deps.indexOf(previousQuestionNumber)] = newQuestionNumber;
            this.questions[tempParent - 1].Qn_Deps.sort(function (a, b) { return a - b });
            tempParent = this.questions[tempParent - 1].Parent_Repeat;
            this.maxTries--;
            if (this.maxTries <= 0) {
              console.log("infinite loop" + tempParent);
              break;
            }
          }

        }

        if (this.questions[whereToAdd + k].Is_Age_Parent != null) {
          for (let p = whereToAdd + k; p < this.questions.length; p++) {
            if (this.questions[p].Parent_Age && this.questions[p].Parent_Age === (previousQuestionNumber)) {
              this.questions[p].Parent_Age = newQuestionNumber;
            }
          }
        }

      }
      this.questions[parentRepeater - 1].Qn_Repeat.sort(function (a, b) { return a - b });

      if (this.questions.length > 0)
        if(this.questions[0].Qn_Disp_Value == "Break")
        this.questions[0].Qn_In = "0";
      else
        this.questions[0].Qn_In = "1";

      this.forIndexes = [];

      for (let i = 1; i < this.questions.length; i++) {


        if (this.questions[i].Parent_Dep === null && this.questions[i].Parent_Repeat === null) {
          this.questions[i].Qn_In = (parseInt(this.questions[i - 1].Qn_In) + 1).toString();
        } else if (this.questions[i].Parent_Dep !== null) {
          if (!this.forIndexes[this.questions[i].Parent_Dep]) {
            this.forIndexes[this.questions[i].Parent_Dep] = 1;
          } else {
            this.forIndexes[this.questions[i].Parent_Dep] = this.forIndexes[this.questions[i].Parent_Dep] + 1;
          }
          this.questions[i].Qn_In = this.questions[this.questions[i].Parent_Dep - 1].Qn_In + "." + (this.forIndexes[this.questions[i].Parent_Dep]);
        } else if (this.questions[i].Parent_Repeat !== null) {
          let count = 1;
          for (let j = this.questions[i].Parent_Repeat; j < i; j++) {
            if (this.questions[j].Parent_Dep === null && this.questions[j].Qn_Type !="Break") {
              count++;
            }
          }
          this.questions[i].Qn_In = this.questions[this.questions[i].Parent_Repeat - 1].Qn_In + "." + count;
        }
      }




    }




    for (let i = 0; i < this.questions.length; i++) {
      this.questions[i].user_Res = [""];
    }
    localStorage.setItem(this.qID, JSON.stringify(this.questions));
    this.broadcastEventService.setQuestions(this.questions);

    this.anomalies = [];
    localStorage.setItem(this.qID + "Anomalies", JSON.stringify(this.anomalies));
    this.anomaliesService.setAnomalies(this.anomalies);
    this.restApiService.updateQnrService(this.qID, JSON.stringify(this.questions), JSON.stringify(this.anomalies), JSON.stringify(this.casLoc), 'd').subscribe(result => { });
  }


  openSettings() {
    this.settingsOpenService.setSettingsOpen(true);
  }


  showAgeChilds(i: number) {
    this.ages[i].childsVisible = !this.ages[i].childsVisible;
  }

  editAge(i: number) {
    let dialogRef = this.editAgeDialog.open(EditAgeDialogComponent, {
      data: {
        questions: this.questions,
        dispValue: 'Age Condition',
        parentQuestion: null,
        newAge: JSON.parse(JSON.stringify(this.ages[i]))
      },
      height: '95vh',
      // height: '608px',
      width: '73.2vw',
      // width: '1000px',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== null) {
        this.ages[i] = result;
        this.questions[this.ages[i].parent - 1].Is_Age_Parent = true;
        this.ageService.setAges(this.ages);
        for (let i = 0; i < this.questions.length; i++) {
          if (this.questions[i].Parent_Age) {
            this.questions[i].Parent_Age = null;
            this.questions[i].Age_Range.pop();
            this.questions[i].Age_Range.pop();
          }
        }

        for (let i = 0; i < this.ages.length; i++) {

          for (let j = 0; j < this.ages[i].childs.length; j++) {
            this.questions[this.ages[i].childs[j] - 1].Parent_Age = this.ages[i].parent;
            this.questions[this.ages[i].childs[j] - 1].Age_Range.push(this.ages[i].low);
            this.questions[this.ages[i].childs[j] - 1].Age_Range.push(this.ages[i].high);
          }

        }


        for (let i = 0; i < this.questions.length; i++) {
          this.questions[i].user_Res = [""];
        }
        localStorage.setItem(this.qID, JSON.stringify(this.questions));
        this.broadcastEventService.setQuestions(this.questions);
        this.restApiService.updateQnrService(this.qID, JSON.stringify(this.questions), JSON.stringify(this.anomalies), JSON.stringify(this.casLoc), 'd').subscribe(result => { });
      }
    });
  }



  deleteAge(i: number) {
    let dialogRef = this.areYouSure.open(AreYouSureDialogComponent, {
      data: {
        cascad: false
      },
      height: '285px',
      width: '400px',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === "Yes") {
        this.ages.splice(i, 1);
        for (let i = 0; i < this.questions.length; i++) {
          if (this.questions[i].Parent_Age) {
            this.questions[i].Parent_Age = null;
            this.questions[i].Age_Range.pop();
            this.questions[i].Age_Range.pop();
          }
        }

        for (let i = 0; i < this.ages.length; i++) {

          for (let j = 0; j < this.ages[i].childs.length; j++) {
            this.questions[this.ages[i].childs[j] - 1].Parent_Age = this.ages[i].parent;
            this.questions[this.ages[i].childs[j] - 1].Age_Range.push(this.ages[i].low);
            this.questions[this.ages[i].childs[j] - 1].Age_Range.push(this.ages[i].high);
          }

        }
      }
    });
  }


  editAnomaly(index: number) {

    let dialogRef = this.editAnomalyDialog.open(EditAnomalyDialogComponent, {
      data: {
        questions: this.questions,
        dispValue: this.anomalies[index].dispValue,
        anomaly: JSON.parse(JSON.stringify(this.anomalies[index])),
        parentQuestion: null
      },
      height: '95vh',
      // height: '608px',
      width: '73.2vw',
      // width: '1000px',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result !== null) {
        this.anomalies[index] = result;
        this.anomalies.sort(function (a, b) {
          return a.Qn_Num - b.Qn_Num;
        });
        this.anomalies[index] = result;
        this.anomaliesService.setAnomalies(this.anomalies);
        localStorage.setItem(this.qID + "Anomalies", JSON.stringify(this.anomalies));
        this.restApiService.updateQnrService(this.qID, JSON.stringify(this.questions), JSON.stringify(this.anomalies), JSON.stringify(this.casLoc), 'd').subscribe(result => { });
      }
    });

  }

  deleteAnomaly(index: number) {

    this.anomalies.splice(index, 1);
    this.anomalies.sort(function (a, b) {
      return a.Qn_Num - b.Qn_Num;
    });
    this.anomaliesService.setAnomalies(this.anomalies);
    this.restApiService.updateQnrService(this.qID, JSON.stringify(this.questions), JSON.stringify(this.anomalies), JSON.stringify(this.casLoc), 'd').subscribe(result => { });
  }

  moveKeyPressInitial(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  moveKeyup(event: any) {

    if (event.target.value.charAt(event.target.value.length - 1) === " ") {
      event.target.value = event.target.value.substring(0, event.target.value.length - 1);
    }
  }


// get the range
getActualMoveUpIndex = (currentIndex,moveUpBy) => {
	const actQnIn = this.questions[currentIndex].Qn_In;
	// if actQnIn length is 1 which means it is a direct questions no child or subchild...  and actualMoveUpIndex should not be less then zero.
  if(!actQnIn.includes('.')){
    console.log('inside direct',actQnIn);
    const moveUpIndex = +actQnIn - moveUpBy;
    if(moveUpIndex >0){
      return this.questions.findIndex(ques => ques.Qn_In == moveUpIndex.toString());
    }
    else{
      return -1;
    }
  }
	else{
		// it means it is a dependent question,either conditional child or repeater child.
		// here conditional question preference remove the repeater question error.
		const parentIndex = this.questions[currentIndex].Parent_Dep?this.questions[currentIndex].Parent_Dep-1:this.questions[currentIndex].Parent_Repeat-1;
        console.log('parent index',parentIndex,this.questions[parentIndex].Qn_Repeat);
		const siblingsQn = this.questions[parentIndex].Qn_Deps && this.questions[parentIndex].Qn_Deps.length>1?this.questions[parentIndex].Qn_Deps:this.questions[parentIndex].Qn_Repeat;
        console.log('parent index',siblingsQn);
		if(!siblingsQn || siblingsQn.length <=0 || siblingsQn.length < moveUpBy){
			return -1;
		}
    for(let j=0; j<siblingsQn.length;j++){
        if(siblingsQn[j] == this.questions[currentIndex].Qn_Num){
            console.log('matchingIndex', j);
            if(j - moveUpBy >=0){
                return siblingsQn[j - moveUpBy]-1
            }
            else{
                return -1;
            }
        }
    }
    return -1;
	}
} 


getActualMoveDownIndex = (currentIndex,moveDownBy) => {
	const actQnIn = this.questions[currentIndex].Qn_In;
	// if actQnIn length is 1 which means it is a direct questions no child or subchild...  and actualMoveUpIndex should not be less then zero.
	if(!actQnIn.includes('.')){
        console.log('inside direct',actQnIn);
        const moveDownIndex = +actQnIn + moveDownBy;
        if(moveDownIndex < this.questions.length){
          return this.questions.findIndex(ques => ques.Qn_In == moveDownIndex);
        }
        else{
          return -1;
        }
	}
	else{
		// it means it is a dependent question,either conditional child or repeater child.
		// here conditional question preference remove the repeater question error.
		const parentIndex = this.questions[currentIndex].Parent_Dep?this.questions[currentIndex].Parent_Dep-1:this.questions[currentIndex].Parent_Repeat-1;
        console.log('parent index',parentIndex,this.questions[parentIndex].Qn_Repeat);
		const siblingsQn = this.questions[parentIndex].Qn_Deps && this.questions[parentIndex].Qn_Deps.length>1?this.questions[parentIndex].Qn_Deps:this.questions[parentIndex].Qn_Repeat;
        console.log('parent index',siblingsQn);
		if(!siblingsQn || siblingsQn.length <=0 || siblingsQn.length < moveDownBy){
			return -1;
		}
    for(let j=0; j<siblingsQn.length;j++){
        if(siblingsQn[j] == this.questions[currentIndex].Qn_Num){
            console.log('matchingIndex', j);
            if(siblingsQn.length > j + moveDownBy){
                return siblingsQn[j + moveDownBy]-1
            }
            else{
                return -1;
            }
        }
    }
    return -1;
	}
} 


getChildWithInitalQnIN = (currentIndex) =>{
	const qnIn = this.questions[currentIndex].Qn_In;
  if(qnIn && !qnIn.includes('.')){
    return [this.questions[currentIndex]];
  }
	const childQuestion = this.questions.filter(ques=> ques.Qn_In && ques.Qn_In.startsWith(qnIn));
	return childQuestion;
}


increaseBy = (qnRepeat,increaseBy)=>{
  if(qnRepeat && qnRepeat.length>0){
    qnRepeat.forEach(data=>{
      data = data+increaseBy;
    });
    return qnRepeat;
  }
  return qnRepeat;
}


arrayReduceBy = (arr,reduceBy)=>{
  if(arr && arr.length>0){
    arr.forEach(data=>{
      data = data- reduceBy;
    })
  }
  return arr;
}

reArrageQuestionsOnMoveUp = (totalQuestions,actualMoveUp) =>{
	const firstQnum = this.questions[actualMoveUp].Qn_Num;
	const firstQnIn = this.questions[actualMoveUp].Qn_In;
	let increment= 0;
	let repeaterDepQues= [];    // can be use if repeater question.
	const reduceIndexBy = totalQuestions[0].Qn_Num - firstQnum;
	totalQuestions.forEach(ques=>{
		ques.Qn_Num = firstQnum + increment;
		repeaterDepQues.push(increment);
		increment = increment+1;
	});
	for(let i=0; i<totalQuestions.length;i++){
		// following function by using : totalQuestions[i].Parent_Dep - reduceIndexBy;
		const parentDepQues = this.arrayReduceBy(totalQuestions[i].Parent_Dep,reduceIndexBy)    // array of questions which are directly dependent on the current question.\
		if(i==0){
			// changes for parent question
			totalQuestions[0].Qn_Repeat = []     // empty repeater question by default, if the below condition is true then we are assigning Qn_Repeat. 
			if(totalQuestions[0].repeater || (totalQuestions[0].Qn_Repeat && totalQuestions[0].Qn_Repeat.length>0)){
				totalQuestions[0].Qn_Repeat = repeaterDepQues
			}
			totalQuestions[0].Qn_Num = this.questions[actualMoveUp].Qn_Num;
			totalQuestions[0].Qn_In = this.questions[actualMoveUp].Qn_In;
			totalQuestions[0].Qn_Deps =  parentDepQues;
			// Parent_Repeat, Parent_Dep is not changing since we are moving within the same parent line or within the same repeater line..
		}
		else{
			// changes for child question  ==> when the parent question is repeater or conditional base question.
			totalQuestions[i].Qn_Num = totalQuestions[0].Qn_Num + i;
			totalQuestions[i].Qn_Deps = parentDepQues;
			totalQuestions[i].Qn_Repeat = [];
			// if the parent question is a repeater question.
			if(totalQuestions[0].repeater || (totalQuestions[0].Qn_Repeat && totalQuestions[0].Qn_Repeat.length>0)){
				totalQuestions[i].Parent_Repeat = totalQuestions[0].Qn_Num
			}
			// if the question has a Parent_Dep
			if(totalQuestions[i].Parent_Dep){
				totalQuestions[i].Parent_Dep = totalQuestions[i].Parent_Dep - reduceIndexBy;
			}
		}
	}
	return totalQuestions;
}

getQnIn = (qnInValues,parent,count) =>{
  let actualQnIn = this.questions[parent -1].Qn_In + '.'+count;
  for(let i=0;i<this.questions.length; i++){
    actualQnIn = this.questions[parent -1].Qn_In + '.'+count;
    if(qnInValues.includes(actualQnIn)){
        count = count + 1;
    }
    else{
        return actualQnIn;
    }
  }
}
reArrangeQnIn = () => {
  let initialParent=null;
  let count = 1;
  let qnIn = 1;
  let qnInValues = [];
  if(this.questions && this.questions.length> 1){
    for(let i=0; i<this.questions.length; i++){
      if(i==0){
        this.questions[i].Qn_In = qnIn.toString();
      }
      else{
        if(this.questions[i].Parent_Dep){
          if(initialParent != this.questions[i].Parent_Dep){
            count =1;
            initialParent = this.questions[i].Parent_Dep;
          }
          this.questions[i].Qn_In = this.getQnIn(qnInValues,initialParent,count);
          count = count + 1;
        }
        else if(this.questions[i].Parent_Repeat && !this.questions[i].Parent_Dep){
          if(initialParent != this.questions[i].Parent_Repeat){
            count =1;
            initialParent = this.questions[i].Parent_Repeat;
          }
          this.questions[i].Qn_In = this.getQnIn(qnInValues,initialParent,count);
          count = count + 1;
        }
        else{
          qnIn = qnIn + 1;
          this.questions[i].Qn_In = qnIn.toString();
        }
      }
      qnInValues.push(this.questions[i].Qn_In);
    }
  }
  return this.questions;
}

sortQuestions = (questions) =>{
  if(questions && questions.length>0){
    questions.sort((a,b)=>a.Qn_Num > b.Qn_Num?1:-1);
  }
  return questions;
}


moveUpByIndex = (currentIndex,moveUpBy) =>{
  const actualMoveUp = this.getActualMoveUpIndex(currentIndex,moveUpBy);
  if(actualMoveUp == -1){
    return;
  }
  const movableQuestions = this.getChildWithInitalQnIN(currentIndex);
  const finalMovableQuestions = this.reArrageQuestionsOnMoveUp(movableQuestions,actualMoveUp);
  for(let i=actualMoveUp; i<= actualMoveUp + movableQuestions.length;i++){
    // increase Qn_Num by 1
    this.questions[i].Qn_Num = this.questions[i].Qn_Num + movableQuestions.length;
    // changing Qn_In at the very last moment.
    // change Qn_Repeat
    this.questions[i].Qn_Repeat = this.increaseBy(this.questions[i].Qn_Repeat,movableQuestions.length);
    // change Qn_Repeat
    this.questions[i].Qn_Deps = this.increaseBy(this.questions[i].Qn_Deps,movableQuestions.length);
    // change Parent_Repeat
    this.questions[i].Parent_Repeat = this.questions[i].Parent_Repeat+movableQuestions.length;
    // change Parent_Dep
    this.questions[i].Parent_Dep = this.questions[i].Parent_Dep+movableQuestions.length;
  }

  // replacing the movable questions values in the questions values.
  let count = 0;
  for(let i= currentIndex;i<currentIndex + movableQuestions.length;i++){
    this.questions[i]=finalMovableQuestions[count];
    count = count + 1;
  }

  //sorting the questions array by Qn_Num.. so that all the questions will be re arrange automatically.
  this.questions = this.sortQuestions(this.questions);
  // now rearranging qn in
  this.reArrangeQnIn();
}

moveDownByIndex = (currentIndex,moveDownBy) => {
  const actualMoveDown = this.getActualMoveUpIndex(currentIndex,moveDownBy);
  if(actualMoveDown == -1){
    return;
  }
  const movableQuestions = this.getChildWithInitalQnIN(currentIndex);
  const finalMovableQuestions = this.reArrageQuestionsOnMoveUp(movableQuestions,actualMoveDown);
  for(let i=actualMoveDown; i<= actualMoveDown + movableQuestions.length;i++){
    // increase Qn_Num by 1
    this.questions[i].Qn_Num = this.questions[i].Qn_Num + movableQuestions.length;
    // changing Qn_In at the very last moment.
    // change Qn_Repeat
    this.questions[i].Qn_Repeat = this.increaseBy(this.questions[i].Qn_Repeat,movableQuestions.length);
    // change Qn_Repeat
    this.questions[i].Qn_Deps = this.increaseBy(this.questions[i].Qn_Deps,movableQuestions.length);
    // change Parent_Repeat
    this.questions[i].Parent_Repeat = this.questions[i].Parent_Repeat+movableQuestions.length;
    // change Parent_Dep
    this.questions[i].Parent_Dep = this.questions[i].Parent_Dep+movableQuestions.length;
  }

  // replacing the movable questions values in the questions values.
  let count = 0;
  for(let i= currentIndex;i<currentIndex + movableQuestions.length;i++){
    this.questions[i]=finalMovableQuestions[count];
    count = count + 1;
  }

  //sorting the questions array by Qn_Num.. so that all the questions will be re arrange automatically.
  this.questions = this.sortQuestions(this.questions);
  // now rearranging qn in
  this.reArrangeQnIn();
}


  moveUp(by: number, question_number: number, event: any) {
    let count: number = 0;

    let firstChildQn: number;
    for (let i = question_number - 2; i >= 0; i--) {

      if (this.questions[i].Parent_Dep === this.questions[question_number - 1].Parent_Dep && this.questions[i].Parent_Repeat === this.questions[question_number - 1].Parent_Repeat) {
        count++;
        if (count == by) {
          firstChildQn = i + 1;
          break;
        }
      }
    }
    if (firstChildQn) {
      this.moveUpClass = "";
      if (event && event.target) {
        event.target.parentElement.parentElement.parentElement.parentElement.classList.remove('open');
      }
    } else {
      this.showToastyService.failure("","Invalid request to move the question to top.");
      this.moveUpClass = "redBottom";
      return;
    }


    let diff = 1 + this.questions[question_number - 1].Qn_Deps.length + this.questions[question_number - 1].Qn_Repeat.length;

    for (let i = firstChildQn - 1; i < question_number - 1; i++) {

      let newQnNumber: number;
      newQnNumber = i + 1 + diff;
      let oldQnNumber: number = i + 1;
      this.questions[i].Qn_Num = newQnNumber;

      if (this.questions[i].Qn_Deps.length > 0) {
        for (let j = 0; j < this.questions[i].Qn_Deps.length; j++) {
          this.questions[this.questions[i].Qn_Deps[j] - 1].Parent_Dep = newQnNumber;
        }
      }

      if (this.questions[i].Qn_Repeat.length > 0) {
        for (let j = 0; j < this.questions[i].Qn_Repeat.length; j++) {
          this.questions[this.questions[i].Qn_Repeat[j] - 1].Parent_Repeat = newQnNumber;
        }
      }

      if (this.questions[i].Parent_Dep) {
        let tempParent = this.questions[i].Parent_Dep;
        this.maxTries = 15;
        while (tempParent !== null) {

          if (tempParent < firstChildQn) {
            this.questions[tempParent - 1].Qn_Deps[this.questions[tempParent - 1].Qn_Deps.indexOf(oldQnNumber)] = newQnNumber;
            this.questions[tempParent - 1].Qn_Deps.sort(function (a, b) { return a - b; });
            tempParent = this.questions[tempParent - 1].Parent_Dep;
          } else {
            this.questions[tempParent - diff - 1].Qn_Deps[this.questions[tempParent - diff - 1].Qn_Deps.indexOf(oldQnNumber)] = newQnNumber;
            this.questions[tempParent - diff - 1].Qn_Deps.sort(function (a, b) { return a - b; });
            tempParent = this.questions[tempParent - diff - 1].Parent_Dep;
          }
          this.maxTries--;
          if (this.maxTries === 1) {
            console.log('infinite loop');
            break;
          }
        }
      }
      if (this.questions[i].Parent_Repeat) {
        let tempParent = this.questions[i].Parent_Repeat;
        if (tempParent < firstChildQn) {
          this.questions[tempParent - 1].Qn_Repeat[this.questions[tempParent - 1].Qn_Repeat.indexOf(oldQnNumber)] = newQnNumber;
          this.questions[tempParent - 1].Qn_Repeat.sort(function (a, b) { return a - b; });
        } else {
          this.questions[tempParent - diff - 1].Qn_Repeat[this.questions[tempParent - diff - 1].Qn_Repeat.indexOf(oldQnNumber)] = newQnNumber;
          this.questions[tempParent - diff - 1].Qn_Repeat.sort(function (a, b) { return a - b; });
        }
      }

      if (this.questions[i].Is_Age_Parent) {
        for (let j = 0; j < this.questions.length; j++) {
          if (this.questions[j].Parent_Age && this.questions[j].Parent_Age === oldQnNumber) {
            this.questions[j].Parent_Age = newQnNumber;
          }
        }
      }

    }

    let till = question_number + this.questions[question_number - 1].Qn_Deps.length + this.questions[question_number - 1].Qn_Repeat.length;

    for (let i = question_number - 1; i < till; i++) {
      let newQnNum ;
      newQnNum = firstChildQn + (i - question_number + 1);      
      let oldQnNum = i + 1;
      let diff = oldQnNum - newQnNum;


      this.questions[i].Qn_Num = newQnNum;

      if (this.questions[i].Qn_Deps.length > 0) {
        for (let j = 0; j < this.questions[i].Qn_Deps.length; j++) {
          this.questions[this.questions[i].Qn_Deps[j] - 1].Parent_Dep = newQnNum;
        }
      }
      if (this.questions[i].Qn_Repeat.length > 0) {
        for (let j = 0; j < this.questions[i].Qn_Repeat.length; j++) {
          this.questions[this.questions[i].Qn_Repeat[j] - 1].Parent_Repeat = newQnNum;
        }
      }

      if (this.questions[i].Parent_Dep) {
        let tempParent = this.questions[i].Parent_Dep;
        this.maxTries = 15;
        while (tempParent !== null) {
          if (tempParent < firstChildQn) {
            this.questions[tempParent - 1].Qn_Deps[this.questions[tempParent - 1].Qn_Deps.indexOf(oldQnNum)] = newQnNum;
            this.questions[tempParent - 1].Qn_Deps.sort(function (a, b) { return a - b; });
            tempParent = this.questions[tempParent - 1].Parent_Dep;
          } else {
            this.questions[tempParent - 1 + diff].Qn_Deps[this.questions[tempParent - 1 + diff].Qn_Deps.indexOf(oldQnNum)] = newQnNum;
            this.questions[tempParent - 1 + diff].Qn_Deps.sort(function (a, b) { return a - b; });
            tempParent = this.questions[tempParent - 1 + diff].Parent_Repeat;
          }
          this.maxTries--;
          if (this.maxTries === 1) {
            console.log('infinite loop');
            break;
          }
        }
      }

      if (this.questions[i].Parent_Repeat) {
        let tempParent = this.questions[i].Parent_Repeat;
        if (tempParent < firstChildQn) {
          this.questions[tempParent - 1].Qn_Repeat[this.questions[tempParent - 1].Qn_Repeat.indexOf(oldQnNum)] = newQnNum;
          this.questions[tempParent - 1].Qn_Repeat.sort(function (a, b) { return a - b; });
        } else {
          this.questions[tempParent - 1 + diff].Qn_Repeat[this.questions[tempParent - 1 + diff].Qn_Repeat.indexOf(oldQnNum)] = newQnNum;
          this.questions[tempParent - 1 + diff].Qn_Repeat.sort(function (a, b) { return a - b; });
        }
      }

      if (this.questions[i].Is_Age_Parent) {
        for (let j = 0; j < this.questions.length; j++) {
          if (this.questions[j].Parent_Age && this.questions[j].Parent_Age === oldQnNum) {
            this.questions[j].Parent_Age = newQnNum;
          }
        }
      }

    }






    let tempQuestion: Questions[] = [];

    till = 1 + this.questions[question_number - 1].Qn_Deps.length + this.questions[question_number - 1].Qn_Repeat.length;
    for (let i = 0; i < till; i++) {
      tempQuestion.push(JSON.parse(JSON.stringify(this.questions[question_number - 1])));
      this.questions.splice(question_number - 1, 1);
    }

    for (let i = 0; i < tempQuestion.length; i++) {
      this.questions.splice(tempQuestion[i].Qn_Num - 1, 0, JSON.parse(JSON.stringify(tempQuestion[i])));
    }



    this.forIndexes = new Array<number>(this.questions.length);

    if (this.questions.length > 0)
       if(this.questions[0].Qn_Disp_Value == "Break")
          this.questions[0].Qn_In = "0";
        else
          this.questions[0].Qn_In = "1";

    for (let i = 1; i < this.questions.length; i++) {

      if (this.questions[i].Parent_Dep === null && this.questions[i].Parent_Repeat === null) {
        if(this.questions[i].Qn_Disp_Value == "Break")
          this.questions[i].Qn_In = (parseInt(this.questions[i - 1].Qn_In)).toString(); 
        else
          this.questions[i].Qn_In = (parseInt(this.questions[i - 1].Qn_In) + 1).toString(); 
      } else if (this.questions[i].Parent_Dep !== null) {
        if (!this.forIndexes[this.questions[i].Parent_Dep]) {
          this.forIndexes[this.questions[i].Parent_Dep] = 1;
        } else {
          this.forIndexes[this.questions[i].Parent_Dep] = this.forIndexes[this.questions[i].Parent_Dep] + 1;
        }
        this.questions[i].Qn_In = this.questions[this.questions[i].Parent_Dep - 1].Qn_In + "." + (this.forIndexes[this.questions[i].Parent_Dep]);
      } else if (this.questions[i].Parent_Repeat !== null) {
        let count = 1;
        for (let j = this.questions[i].Parent_Repeat; j < i; j++) {
          if (this.questions[j].Parent_Dep === null && this.questions[j].Qn_Type !="Break") {
            count++;
          }
        }
        this.questions[i].Qn_In = this.questions[this.questions[i].Parent_Repeat - 1].Qn_In + "." + count;
      }
    }


    for (let i = 0; i < this.questions.length; i++) {
      this.questions[i].user_Res = [""];
    }
    localStorage.setItem(this.qID, JSON.stringify(this.questions));
    this.broadcastEventService.setQuestions(this.questions);
    this.anomalies = [];
    localStorage.setItem(this.qID + "Anomalies", JSON.stringify(this.anomalies));
    this.anomaliesService.setAnomalies(this.anomalies);
    this.restApiService.updateQnrService(this.qID, JSON.stringify(this.questions), JSON.stringify(this.anomalies), JSON.stringify(this.casLoc), 'd').subscribe(result => { });
    //this.moveUpClass = "redBottom";
    //$event.target.parentElement.parentElement.parentElement.parentElement.classList.remove('open');
  }

  moveDown(by: number, question_number: number, event: any) {



    let count: number = 0;

    let lastSubChildQn: number;
    let firstChildQn: number;

    for (let i = question_number; i < this.questions.length; i++) {
      if (this.questions[i].Parent_Dep === this.questions[question_number - 1].Parent_Dep && this.questions[i].Parent_Repeat === this.questions[question_number - 1].Parent_Repeat) {
        count++;
        if (count === 1) {
          firstChildQn = i + 1;
        }
        if (count == by) {
          lastSubChildQn = i + 1;
          break;
        }
      }

    }

    if (lastSubChildQn) {
      //console.log(this.questions[firstChildQn -1].Qn);
      //console.log(this.questions[lastSubChildQn -1].Qn);
      this.moveDownClass = "";
      if (event && event.target) {
        event.target.parentElement.parentElement.parentElement.parentElement.classList.remove('open');
      }
    } else {
      this.showToastyService.failure("","Invalid request to move the question at bottom.");
      this.moveDownClass = "redBottom";
      return;
    }

    let tillSubChild: number = lastSubChildQn + this.questions[lastSubChildQn - 1].Qn_Deps.length + this.questions[lastSubChildQn - 1].Qn_Repeat.length;

    for (let i = firstChildQn - 1; i < tillSubChild; i++) {


      let newQnNumber = i - this.questions[question_number - 1].Qn_Repeat.length - this.questions[question_number - 1].Qn_Deps.length;
      let oldQnNumber = i + 1;
      let diff = oldQnNumber - newQnNumber;

      this.questions[i].Qn_Num = newQnNumber;


      if (this.questions[i].Qn_Deps.length > 0) {
        for (let j = 0; j < this.questions[i].Qn_Deps.length; j++) {
          this.questions[this.questions[i].Qn_Deps[j] - 1].Parent_Dep = newQnNumber;
        }
      }

      if (this.questions[i].Qn_Repeat.length > 0) {
        for (let j = 0; j < this.questions[i].Qn_Repeat.length; j++) {
          this.questions[this.questions[i].Qn_Repeat[j] - 1].Parent_Repeat = newQnNumber;
        }
      }

      if (this.questions[i].Parent_Dep) {
        let tempParent = this.questions[i].Parent_Dep;
        this.maxTries = 15;
        while (tempParent !== null) {
          if (tempParent < question_number) {
            this.questions[tempParent - 1].Qn_Deps[this.questions[tempParent - 1].Qn_Deps.indexOf(oldQnNumber)] = newQnNumber;
            this.questions[tempParent - 1].Qn_Deps.sort(function (a, b) { return a - b; });
            tempParent = this.questions[tempParent - 1].Parent_Dep;
          } else {

            this.questions[tempParent + diff - 1].Qn_Deps[this.questions[tempParent + diff - 1].Qn_Deps.indexOf(oldQnNumber)] = newQnNumber;
            this.questions[tempParent + diff - 1].Qn_Deps.sort(function (a, b) { return a - b; });
            tempParent = this.questions[tempParent + diff - 1].Parent_Dep;
          }
          this.maxTries--;
          if (this.maxTries === 1) {
            // console.log('infinite loop');
            // console.log(this.questions[i].Qn);
            break;
          }
        }
      }

      if (this.questions[i].Parent_Repeat) {
        let tempParent = this.questions[i].Parent_Repeat;
        if (tempParent < question_number) {
          this.questions[tempParent - 1].Qn_Repeat[this.questions[tempParent - 1].Qn_Repeat.indexOf(oldQnNumber)] = newQnNumber;
          this.questions[tempParent - 1].Qn_Repeat.sort(function (a, b) { return a - b; });
        } else {
          this.questions[tempParent + diff - 1].Qn_Repeat[this.questions[tempParent + diff - 1].Qn_Repeat.indexOf(oldQnNumber)] = newQnNumber;
          this.questions[tempParent + diff - 1].Qn_Repeat.sort(function (a, b) { return a - b; });
        }
      }

      if (this.questions[i].Is_Age_Parent) {
        for (let j = 0; j < this.questions.length; j++) {
          if (this.questions[j].Parent_Age && this.questions[j].Parent_Age === oldQnNumber) {
            this.questions[j].Parent_Age = newQnNumber;
          }
        }
      }



    }




    for (let i = question_number - 1; i < firstChildQn - 1; i++) {

      let newQnNumber = (tillSubChild - firstChildQn + 1) + (i + 1);
      let oldQnNumber = i + 1;
      let diff = newQnNumber - oldQnNumber;
      this.questions[i].Qn_Num = newQnNumber;

      if (this.questions[i].Qn_Deps.length > 0) {
        for (let j = 0; j < this.questions[i].Qn_Deps.length; j++) {
          this.questions[this.questions[i].Qn_Deps[j] - 1].Parent_Dep = newQnNumber;
        }
      }

      if (this.questions[i].Qn_Repeat.length > 0) {
        for (let j = 0; j < this.questions[i].Qn_Repeat.length; j++) {
          this.questions[this.questions[i].Qn_Repeat[j] - 1].Parent_Repeat = newQnNumber;
        }
      }

      if (this.questions[i].Parent_Dep) {
        let tempParent = this.questions[i].Parent_Dep;
        this.maxTries = 15;
        while (tempParent !== null) {
          if (tempParent < question_number) {
            this.questions[tempParent - 1].Qn_Deps[this.questions[tempParent - 1].Qn_Deps.indexOf(oldQnNumber)] = newQnNumber;
            this.questions[tempParent - 1].Qn_Deps.sort(function (a, b) { return a - b; });
            tempParent = this.questions[tempParent - 1].Parent_Dep;
          } else {
            this.questions[tempParent - diff - 1].Qn_Deps[this.questions[tempParent - diff - 1].Qn_Deps.indexOf(oldQnNumber)] = newQnNumber;
            this.questions[tempParent - diff - 1].Qn_Deps.sort(function (a, b) { return a - b; });
            tempParent = this.questions[tempParent - diff - 1].Parent_Dep;
          }
          this.maxTries--;
          if (this.maxTries === 1) {
            console.log("infinite loop");
            console.log((this.questions[i].Qn));
            break;
          }
        }
      }

      if (this.questions[i].Parent_Repeat) {
        let tempParent = this.questions[i].Parent_Repeat;
        if (tempParent < question_number) {
          this.questions[tempParent - 1].Qn_Repeat[this.questions[tempParent - 1].Qn_Repeat.indexOf(oldQnNumber)] = newQnNumber;
          this.questions[tempParent - 1].Qn_Repeat.sort(function (a, b) { return a - b; });
        } else {
          this.questions[tempParent - diff - 1].Qn_Repeat[this.questions[tempParent - diff - 1].Qn_Repeat.indexOf(oldQnNumber)] = newQnNumber;
          this.questions[tempParent - diff - 1].Qn_Repeat.sort(function (a, b) { return a - b; });
        }
      }

      if (this.questions[i].Is_Age_Parent) {
        for (let j = 0; j < this.questions.length; j++) {
          if (this.questions[j].Parent_Age && this.questions[j].Parent_Age === oldQnNumber) {
            this.questions[j].Parent_Age = newQnNumber;
          }
        }
      }

    }
    let tempQuestions: Questions[] = [];
    let till = 1 + this.questions[question_number - 1].Qn_Deps.length + this.questions[question_number - 1].Qn_Repeat.length;

    for (let i = 0; i < till; i++) {
      tempQuestions.push(JSON.parse(JSON.stringify(this.questions[question_number - 1])));
      this.questions.splice(question_number - 1, 1);
    }



    for (let j = 0; j < tempQuestions.length; j++) {
      this.questions.splice(tempQuestions[j].Qn_Num - 1, 0, JSON.parse(JSON.stringify(tempQuestions[j])));
    }



    this.forIndexes = new Array<number>(this.questions.length);

    if (this.questions.length > 0)
      if(this.questions[0].Qn_Disp_Value == "Break")
        this.questions[0].Qn_In = "0";
      else
        this.questions[0].Qn_In = "1";

    for (let i = 1; i < this.questions.length; i++) {


      if (this.questions[i].Parent_Dep === null && this.questions[i].Parent_Repeat === null) {
        if(this.questions[i].Qn_Disp_Value == "Break")
          this.questions[i].Qn_In = (parseInt(this.questions[i - 1].Qn_In)).toString(); 
        else
          this.questions[i].Qn_In = (parseInt(this.questions[i - 1].Qn_In) + 1).toString();
      } else if (this.questions[i].Parent_Dep !== null) {
        if (!this.forIndexes[this.questions[i].Parent_Dep]) {
          this.forIndexes[this.questions[i].Parent_Dep] = 1;
        } else {
          this.forIndexes[this.questions[i].Parent_Dep] = this.forIndexes[this.questions[i].Parent_Dep] + 1;
        }
        this.questions[i].Qn_In = this.questions[this.questions[i].Parent_Dep - 1].Qn_In + "." + (this.forIndexes[this.questions[i].Parent_Dep]);
      } else if (this.questions[i].Parent_Repeat !== null) {
        let count = 1;
        for (let j = this.questions[i].Parent_Repeat; j < i; j++) {
          if (this.questions[j].Parent_Dep === null && this.questions[j].Qn_Type !="Break")  {
            count++;
          }
        }
        this.questions[i].Qn_In = this.questions[this.questions[i].Parent_Repeat - 1].Qn_In + "." + count;
      }
    }



    for (let i = 0; i < this.questions.length; i++) {
      this.questions[i].user_Res = [""];
    }
    localStorage.setItem(this.qID, JSON.stringify(this.questions));
    this.broadcastEventService.setQuestions(this.questions);

    this.anomalies = [];
    localStorage.setItem(this.qID + "Anomalies", JSON.stringify(this.anomalies));
    this.anomaliesService.setAnomalies(this.anomalies);

    this.restApiService.updateQnrService(this.qID, JSON.stringify(this.questions), JSON.stringify(this.anomalies), JSON.stringify(this.casLoc), 'd').subscribe(result => { });


  }

  moveToTop(question_number: number) {
    let by: number = 0;
    for (let i = question_number - 2; i >= 0; i--) {
      if (this.questions[question_number - 1].Parent_Repeat === this.questions[i].Parent_Repeat && this.questions[question_number - 1].Parent_Dep === this.questions[i].Parent_Dep) {
        by++;
      }
    }
    this.moveUp(by, question_number, "");
  }

  moveToBottom(question_number: number) {
    let by: number = 0;
    for (let i = question_number; i < this.questions.length; i++) {
      if (this.questions[question_number - 1].Parent_Repeat === this.questions[i].Parent_Repeat && this.questions[question_number - 1].Parent_Dep === this.questions[i].Parent_Dep) {
        by++;
      }
    }
    this.moveDown(by, question_number, "");
  }


  moveFromChild(str: string[]) {

    if (str[0] === 'up') {
      this.moveUp(parseInt(str[1]), parseInt(str[2]), "");
    } else if (str[0] === 'down') {
      this.moveDown(parseInt(str[1]), parseInt(str[2]), "");
    } else if (str[0] === 'toTop') {
      this.moveToTop(parseInt(str[2]));
    } else {
      this.moveToBottom(parseInt(str[2]));
    }

  }

  moveDropdownTriggered() {
    this.moveDownClass = "";
    this.moveUpClass = "";
  }

  returnIcon(type: string): string {
    let index = this.questionTypesList.findIndex(question => question.displayValue === type)
    if(index > -1){
      return this.questionTypesList[index].icon;
    }
  }
}

export class Tabs {
  name: string;
  label: string;
  isVisible: boolean;
  class: string;
}

class QuestionTypes {
  questionType: string;
  displayValue: string;
  icon: string;
}




@Component({
  selector: 'assign-team-dialog',
  templateUrl: './assign-team-dialog.html',
  styleUrls: ['assign-team-dialog.css']
})
export class AssignTeamComponent implements OnInit {

  teamList: {id:string,teamName:string,surveyorCount:number,action:boolean,
    defineArea:boolean, qIds:string[],qNames:string[],uIds:string[],adminID:string}[]=[];
  displayedColumns= ['teamName','surveyorCount','action','defineArea'];
  surveyId:string;
  surveyName:string;
  showLoader = false;
  fromSurvey = false;
  constructor(public restApiService: RestApiService,
    public dialogRef: MatDialogRef<AssignTeamComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any,private dialog:MatDialog) {
      if(data){
        this.surveyId = data.surveyId;
        this.surveyName = data.surveyName;
        if(data.fromSurvey){
          this.fromSurvey = true;
        }
      }
  }

  ngOnInit(){
    this.getTeamList();
  }

  getTeamList(){
    this.showLoader = true;
    this.restApiService.getGroupListWithDetailsForAdminService(null).subscribe(response=>{
      if(response && response.success && response.groups){
        let areaDefinedList:{id:string,areaDefined:boolean}[] =[];
        this.restApiService.getTeamListForAdminSurvey(this.surveyId).subscribe(response2=>{
          if(response2 && response2.success){
            const teamlist = response2.data;
            teamlist.forEach(teamData=>{
              let areaDefined = teamData.area_details != null? true:false;
              areaDefinedList.push({id:teamData.id,areaDefined:areaDefined});


              this.teamList = [];
              const teams = response.groups;
              teams.forEach(team => {
                const teamName= team.teamName;
                let count = 0;
                if(team.uIDs && team.uIDs.length>0){
                  team.uIDs.forEach(data=>{
                    if(data != null || data != 'null'){
                      count = count +1;
                    }
                  })
                }
                const surveyorCount = count;
                let action = false;
                if(team.qIDs && team.qIDs.length >0 ){
                  if(team.qIDs.includes(this.surveyId)){
                    action = true;
                  }
                }
                let areaDefined = false;
                for (let index = 0; index < areaDefinedList.length; index++) {
                  if(areaDefinedList[index].id == team.id){
                    areaDefined = areaDefinedList[index].areaDefined;
                  }
                }
                this.teamList.push({id:team.id,teamName:teamName,surveyorCount:count,
                  action:action, defineArea:areaDefined,qIds:team.qIDs,qNames:team.qNames,
                  uIds:team.uIDs,adminID:team.adminID});
              })
            })
          }
          this.showLoader = false;
        },
        error=>{
          this.showLoader = false;
        })
      }
      this.showLoader = false;
    },
    error=>{
      this.showLoader = false;
    })
  }

  defineAreaForSurvey(row){
    let qIDs = [];
    let qNames = [];
    let uIDs = [];
    row.surveyName = this.surveyName;
    if(row.action)
    {
      row.teamID = row.id;
      row.qID = this.surveyId;
      let dialogRef = this.dialog.open(DefineAreaModalComponent, {
        height: '600px',
        width: '88rem',
        data: row
      })
      dialogRef.afterClosed().subscribe(result=>{
        row.defined_area = result.count;
        // console.log(result);
      })
    }
  }

  onClose(){
    this.dialogRef.close(false);
  }

  publishSurvey(){
    this.dialogRef.close(true);
  }
  
  actionSurvey(row) {
    let qNames = row.qNames;
    let qIds = row.qIds;
    const uIds = row.uIds;
    const teamName = row.teamName;
    const adminId = row.adminID;
    if (!row.action) {
      qNames.push(this.surveyName);
      qIds.push(this.surveyId);
    }
    else {
      let index = qNames.indexOf(this.surveyName);
      if (index != -1) {
        qNames.splice(index, 1);
      }
      index = qIds.indexOf(this.surveyId);
      if (index != -1) {
        qIds.splice(index, 1);
      }
    }
    // do not assign or unassign team if qID is null..
    if(qIds.includes(null) || qIds.includes(undefined) || qIds.includes('undefined')){
      console.log("qIDs must not have null or undefined values.");
      return;
    }

    this.restApiService.assignSurveysToGroupService(uIds, teamName, qNames, qIds,adminId).subscribe(
      result => {
        if (result.success != false) {
          if(!row.action)
          {
            row.action = true;
          }
          else {
            row.action = false;
          }
        }
        else {
          console.log("fail" + result.msg);
        }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/centralPanel/central-panel.component.ts